import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Container from "../ui/Container";

const Products = () => {
  const products = [
    {
      id: "sa-inventory",
      name: "SA Inventory",
      description: "Система управления товарными запасами для ритейла и e-commerce. Оптимизирует процессы закупок, хранения и учета товаров.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 6v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8.5"></path>
          <path d="M2 12v2a2 2 0 0 0 2 2h4"></path>
          <path d="M2 6v6"></path>
          <path d="M18 18h0"></path>
          <path d="M6 15v0"></path>
          <path d="M12 13V7a1 1 0 0 0-1-1H7"></path>
          <path d="M3 3l18 18"></path>
        </svg>
      ),
      category: "Управление запасами"
    },
    {
      id: "sa-retail",
      name: "SA Retail",
      description: "Комплексное решение для управления розничным бизнесом. Включает управление магазинами, продажами и персоналом.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"></path>
          <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
          <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"></path>
          <path d="M2 7h20"></path>
          <path d="M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12v0a2 2 0 0 1-2-2V7"></path>
        </svg>
      ),
      category: "Розничная торговля"
    },
    {
      id: "sa-delivery",
      name: "SA Delivery",
      description: "Система управления доставкой для e-commerce и логистических компаний. Оптимизирует маршруты и ускоряет доставку.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 12V6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v12l-2 2H7l-2-2Z"></path>
          <path d="M5 12H3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2"></path>
          <path d="M9 3v3"></path>
          <path d="M15 3v3"></path>
          <path d="M15 16a1 1 0 1 0 2 0 1 1 0 1 0-2 0Z"></path>
          <path d="M7 16a1 1 0 1 0 2 0 1 1 0 1 0-2 0Z"></path>
        </svg>
      ),
      category: "Логистика"
    },
    {
      id: "secret-card",
      name: "Secret Card",
      description: "Платформа для управления системами лояльности и подарочными картами. Повышает удержание клиентов и увеличивает средний чек.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect width="20" height="14" x="2" y="5" rx="2"></rect>
          <line x1="2" x2="22" y1="10" y2="10"></line>
        </svg>
      ),
      category: "Лояльность"
    },
    {
      id: "fh-by",
      name: "FH.BY",
      description: "Сайт и мобильное приложения для e-commerce с единым backend и удобной административной панелью. Обеспечиваем полный контроль и управление бизнесом.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"></path>
          <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
          <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"></path>
          <path d="M2 7h20"></path>
          <path d="M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12v0a2 2 0 0 1-2-2V7"></path>
        </svg>
      ),
      category: "Розничная торговля"
    },
    {
      id: "pos",
      name: "POS",
      description: "Современная POS-система для приема платежей и управления продажами. Поддерживает различные способы оплаты и интеграции.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect width="18" height="18" x="3" y="3" rx="2"></rect>
          <circle cx="9" cy="9" r="2"></circle>
          <path d="M15 9h.01"></path>
          <path d="M15 15h.01"></path>
          <path d="M9 15h.01"></path>
        </svg>
      ),
      category: "Платежи"
    }
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute left-0 top-1/3 w-1/4 h-1/3 bg-accent/5 rounded-full blur-3xl"></div>
        <div className="absolute right-0 bottom-1/3 w-1/3 h-1/3 bg-primary/5 rounded-full blur-3xl"></div>
      </div>

      <Container>
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="tag mb-4 mx-auto inline-block">Наши продукты</div>
          <h2 className="heading text-3xl md:text-4xl font-bold mb-6">
            Инновационные <span className="text-gradient">программные решения</span> для бизнеса
          </h2>
          <p className="text-muted-foreground text-lg">
            Мы разрабатываем специализированные программные продукты, которые помогают ритейлерам, e-commerce компаниям и логистическим предприятиям оптимизировать процессы и увеличивать прибыль.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {products.map((product, index) => (
            <div 
              key={product.id} 
              className="relative group bg-white rounded-2xl p-6 shadow-sm border border-border hover:border-primary/20 hover:shadow-md transition-all duration-300"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-accent/5 opacity-0 group-hover:opacity-100 rounded-2xl transition-opacity duration-300"></div>
              <div className="relative z-10">
                <div className="w-12 h-12 bg-secondary flex items-center justify-center rounded-lg mb-5 text-primary">
                  {product.icon}
                </div>
                <div className="tag mb-3">{product.category}</div>
                <h3 className="text-xl font-semibold mb-3">{product.name}</h3>
                <p className="text-muted-foreground mb-5 text-sm">{product.description}</p>
                  {/* <Link to={`/products/${product.id}`} className="inline-flex items-center text-primary font-medium">
                    Подробнее
                    <ArrowRight className="ml-2 h-4 w-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                  </Link> */}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/products" className="button-primary">
            Смотреть все продукты
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default Products;
